export class AccordionToggle {
  constructor() {
    return {
      link: function(scope, element, attr) {
        element.on('click', () => {
          if(scope.$parent.$parent.activeChatOptions) scope.$parent.$parent.activeChatOptions = null;
          const leave = (roomID) => {
            scope.activeChatAccordion.room_id = '';
            scope.activeChatAccordion.isLoad = false;
            scope.leaveChatRoom(roomID);
            $('.content#'+roomID)
              .removeClass('active')
              .parent('dd').removeClass('active');
          },

          load = (roomID) => {
            scope.activeChatAccordion.room_id = roomID;
            scope.activeChatAccordion.isLoad = true;
            scope.loadChatRoom(roomID);
            $('.content#'+roomID)
              .addClass('active')
              .parent('dd').addClass('active');
          };

          if(scope.activeChatAccordion.isLoad){
            if(scope.activeChatAccordion.room_id !== attr.accordionToggle){
              leave(scope.activeChatAccordion.room_id);
              load(attr.accordionToggle);
            } else {
              leave(scope.activeChatAccordion.room_id);
            }
          }
          else {
            load(attr.accordionToggle);
          }
        });
      }
    }
  }
}
